<template>
	<div class="class-list" v-if="list.length > 0">
		<div class="class-item" v-for="(item, index) in list" :key="item.id" @click="showClassInfo(item.id)">
			<h4 class="class-item_name">{{ item.class_name }}</h4>
			<p class="class-item_center">{{ item.class_department.name }}</p>
			<i class="iconfont icon-getin"></i>
		</div>
		<div class="class-item class-add flex-center" style="display: none;">
			<img src="~@/assets/img/addClass.png" alt="">
		</div>
	</div>
	<div class="no-class" v-else>暂无班级</div>
</template>

<script>
	import { getClassList } from '@/api/class';
	export default {
		name: "classList",
		data() {
			return {
				list: [],
			}
		},
		mounted() {
			this.getClassList();
		},
		methods: {
			getClassList() { // 获取班级列表
				getClassList().then(res => {
					this.list = res.data.list.data;
				})
			},
			showClassInfo(id) {
				this.$router.push({
					name: "classInfo",
					query: {
						classId: id 
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.class-list {
		padding: 1.6rem 0.8rem !important;

		display: flex;
		justify-content: start;
		flex-wrap: wrap;

		.class-item {
			width: 15.2rem;
			height: 9.2rem;
			background: url(~@/assets/img/classinBg.png) no-repeat;
			background-size: 100% 100%;
			border-radius: 0.8rem;
			margin: 0.6rem 0.6rem;
			padding: 0.8rem;
			position: relative;
			cursor: pointer;
			font-size: 0.8rem;
			font-weight: 500;
			color: #50FDFF;
			box-sizing: border-box;

			.class-item_name {
				font-weight: 100;
			}

			.class-item_center {
				margin: 0.8rem 0;
				line-height: 1.2rem;
			}

			.iconfont {
				font-size: 1.68rem;
				position: absolute;
				bottom: 1.6rem;
			}
		}

		.class-add {
			background: #155A87;
			border: 2px solid #3CA0E1;
		}
	}

	.no-class{
		color: #FFF;
		font-size: 1.28rem;
		text-align: center;
		margin-bottom: 1.4rem;
		margin-top: 1.6rem;
	}
</style>
